import { APIService } from "services";

export const getStep_Discounts = async (pageNo, pageSize, search) => {
  let res;
  if (search.length === 0) {
    res = await getAllStep_Discounts(pageNo, pageSize);
  } else {
    try {
      res = await searchStep_Discounts(search, pageNo, pageSize);
    } catch (err) {
      return { records: [], totalCount: 0 };
    }
  }
  if (res && res.data) {
    return res.data;
  } else {
    return { records: [], totalCount: 0 };
  }
};

export const addStep_Discounts = (data) => {
  return APIService.api().post(`/step_discounts`, data);
};
export const updateStep_Discounts = (id, data) => {
  return APIService.api().patch(`/step_discounts/${id}`, data);
};
export const getAllStep_Discounts = (pageNo, pageSize) => {
  return APIService.api().get(
    `/step_discounts/?pageNo=${pageNo}&pageSize=${pageSize}`
  );
};
export const getOneStep_Discounts = (id) => {
  return APIService.api().get(`/step_discounts/${id}`);
};
export const searchStep_Discounts = (searchKey, pageNo, pageSize) => {
  return APIService.api().get(
    `/step_discounts/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`
  );
};
export const deleteStep_Discounts = (id) => {
  return APIService.api().delete(`/step_discounts/${id}`);
};
